import { render, staticRenderFns } from "./UserProfilingBasics.vue?vue&type=template&id=4ed99567"
import script from "./UserProfilingBasics.vue?vue&type=script&lang=js"
export * from "./UserProfilingBasics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports